/**
 * useAuth — separate file so the AuthProvider module remains
 * component-only-export-friendly for Fast Refresh (oxlint's
 * `react/only-export-components` rule).
 */
import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthContext';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an <AuthProvider>.');
  }
  return ctx;
}
